import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule, Routes } from '@angular/router';
import { ExternalLinkDirectiveModule } from '@commons/directives/external-link/external-link.directive';
import { AccessHelpsHeroComponent } from '@features/access-helps/access-helps-hero/access-helps-hero.component';
import { ViewComponent } from '@features/access-helps/view/view.component';

const routes: Routes = [
  {
    path: '',
    component: ViewComponent,
  },
];

@NgModule({
  declarations: [ViewComponent, AccessHelpsHeroComponent],
  imports: [CommonModule, RouterModule.forChild(routes), MatIconModule, ExternalLinkDirectiveModule],
})
export class AccessHelpsModule {}
